//component to upload multiple files on s3, will reject even if one file fails to upload
//sample presign_urls obj- {filename1:url1,filename2:url2}
//activeFiles should be array of files

import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import { MultiFileUploadS3 } from "../../../utils/FileUpload";
import { connect } from "react-redux";
import Plus from "sushiweb/Icons/all/Plus";
import { bindActionCreators } from "redux";
import * as userActions from "../../../store/actions/User";
import Errors from "../../../constants/Errors.json";
import SuccessMessages from "../../../constants/SucessMessages.json";
import PropTypes from "prop-types";
import commonStyles from "../../../static/styles/common";

const useStyles = makeStyles((_theme) => commonStyles.fileUploadButton);

const MultiFileUpload = (props) => {
  const {
    title,
    presign_urls,
    callback_key,
    uploadUrl,
    setStatus,
    handleClose = () => {},
    keyName,
    activeFiles = [],
    setActiveFiles,
    onError,
    disabled,
    acceptTypes,
    maxSize,
    maxSizeInKb,
    UploadIcon,
    heading, //either send title or heading
    extraParamsAckObj, // extra params to send to ack call along with callback key
    handleFileUploadSuccess, //call this function when file upload is successful
  } = props;
  const classes = useStyles();

  const handleChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) {
      return;
    }
    if (maxSize) {
      for (let i = 0; i < files.length; i++) {
        if (files[i].size > maxSize * 1048576) {
          setStatus({
            type: "error",
            message: "Please select file less than " + maxSize + " MB",
          });
          return;
        }
      }
    }
    if (maxSizeInKb) {
      for (let i = 0; i < files.length; i++) {
        if (Math.floor(files[i].size / 1024) > maxSizeInKb) {
          setStatus({
            type: "error",
            message: "Please select file less than " + maxSizeInKb + " KB",
          });
          return;
        }
      }
    }
    setActiveFiles(files);
  };

  useEffect(() => {
    if (
      callback_key &&
      presign_urls &&
      Object.keys(presign_urls).length > 0 &&
      activeFiles.length > 0
    ) {
      MultiFileUploadS3(
        callback_key,
        presign_urls,
        activeFiles,
        uploadUrl,
        keyName,
        undefined,
        extraParamsAckObj
      )
        .then((url) => {
          if (typeof handleFileUploadSuccess === "function") {
            handleFileUploadSuccess();
          }
          handleClose("success");
          setStatus({
            type: "success",
            message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
          });
        })
        .catch((err) => {
          console.log(err);
          if (onError) {
            if (typeof onError == "function") {
              onError(err);
              return;
            }
          }
          handleClose("failure");
          setStatus({
            type: "error",
            message: typeof err === "string" ? err : Errors.FILE_UPLOAD_FAILED,
          });
        });
    } else if (callback_key && presign_urls && !activeFiles.length) {
      setStatus({ type: "error", message: Errors.NO_FILE_SELECTED });
    }
  }, [callback_key, presign_urls]);

  return (
    <FileUploadComponent className="file-upload-box">
      <Button
        icon={<Plus />}
        className={classes.uploadButton}
        variant="outlined"
        component="label"
        disabled={disabled}
      >
        {UploadIcon ? <span className="upload-icon">{UploadIcon}</span> : ""}
        {heading ? heading : `Upload ${title || "File"}`}
        <input
          // disabled={callback_key}
          type="file"
          hidden
          onClick={(e) => {
            e.target.value = null;
          }}
          id="file-input"
          multiple
          onChange={handleChange}
          accept={acceptTypes ? acceptTypes : undefined}
        />
      </Button>
      {activeFiles.length > 0 &&
        activeFiles.map((file, index) => {
          return (
            <p key={index} className={`${classes.fileName} mt-10`}>
              {file.name}
            </p>
          );
        })}
    </FileUploadComponent>
  );
};

const FileUploadComponent = styled.div`
  label {
    width: 100%;
  }
  .upload-icon {
    margin-right: 10px;
    margin-bottom: 5px;
  }
`;

MultiFileUpload.defaultProps = {
  disabled: false,
};

MultiFileUpload.propTypes = {
  title: PropTypes.string,
  presign_urls: PropTypes.object.isRequired,
  callback_key: PropTypes.string.isRequired,
  uploadUrl: PropTypes.string.isRequired,
  keyName: PropTypes.string.isRequired,
  activeFiles: PropTypes.array.isRequired,
  setActiveFiles: PropTypes.func.isRequired,
  handleClose: PropTypes.func,
  setStatus: PropTypes.func,
  onError: PropTypes.func,
  acceptTypes: PropTypes.string,
  // maxsize is in Mega Bytes
  maxSize: PropTypes.number,
};

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    setStatus: bindActionCreators(userActions.setStatus, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MultiFileUpload);
